module.exports = __webpack_public_path__ + "img/chargingpoint-fastcharger-rejected.89a45660.png";